// String format functions taken from StackOverflow:
// http://stackoverflow.com/questions/610406/javascript-equivalent-to-printf-string-format
// String format function for C#-like use:
// String.format("{0}, {1}!", "Hello", "Joe") ==> "Hello, Joe!"
if (!String.format) {
  String.format = function(format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
  };
}

if (!String.prototype.format) {
  String.prototype.format = function() {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
  };
}

// Color functions taken from StackOverflow:
// http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
export function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}

export function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

// This one's mine. Given hex, returns "rgb(r, g, b)" string
export function hexToRgbString(hex) {
    var rgb = hexToRgb(hex);

    return "rgb({0}, {1}, {2})".format(rgb.r, rgb.g, rgb.b);
}

// Converts an "hh:mm::ss,(milliseconds)" string to the total second count. Fractional seconds supported
export function hmsToSeconds(str) {
    var hms = str.split(":");
    var h = parseInt(hms[0]);
    var m = parseInt(hms[1]);

    var sms = hms[2].split(",");
    var s = parseFloat(sms[0])
    var ms = parseInt(sms[1]);

    return (h * 3600) + (m * 60) + s + (ms / 1000.0);
}

// Converts a number of seconds (d) into a string of hh:mm:ss,(milliseconds) for use with SRT formatting
export function secondsToHms(d, padding = true, includeZeros = true, useCommaMS = true) {
    d = Number(d);
    let hours = Math.floor(d / 3600);
    let minutes = Math.floor(d % 3600 / 60);
    let seconds = Math.floor(d % 3600 % 60);
    let milliseconds = Math.round((d % 1) * 1000);

    let h, m, s, ms;

    if (padding) {
      h = pad(hours, 2);
      m = pad(minutes, 2);
      s = pad(seconds, 2);
      ms = pad(milliseconds, 3);
    }
    else {
      h = hours.toString();
      m = minutes.toString();
      s = seconds.toString();
      ms = milliseconds.toString();
    }

    let sep = useCommaMS ? "," : ".";

    if (!includeZeros) {
      h = hours > 0 ? h + ":" : "";
      m = minutes > 0 ? m + ":" : "";
      s = seconds > 0 ? s : "";
      ms = milliseconds > 0 ? sep + ms : "";
    }
    else {
      h = h + ":";
      m = m + ":";
      s = s;
      ms = sep + ms;
    }

    return String.format("{0}{1}{2}{3}", h, m, s, ms);
}

export function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

// Error logging snippet coming from this blog:
// http://openmymind.net/2012/4/4/You-Really-Should-Log-Client-Side-Error/
// function logError(details) {
//     if (!Deployment.api) return;
//     $.ajax({
//         type: 'POST',
//         url: '',
//         data: JSON.stringify(btoa(JSON.stringify({context: navigator.userAgent, details: details, deployment: Deployment},
//             null, 2))),
//         contentType: 'application/json; charset=utf-8'
//     });
// }

// function logMessage(details) {
//     if (!Deployment.api) return;
//     $.ajax({
//         type: 'POST',
//         url: '',
//         data: JSON.stringify(btoa(JSON.stringify({context: navigator.userAgent, details: details, deployment: Deployment},
//             null, 2))),
//         contentType: 'application/json; charset=utf-8'
//     });
// }

// // Scene logging snippet from me
// function logScene(scene) {
//     if (!Deployment.api) return;
//     $.ajax({
//         type: 'POST',
//         url: '',
//         data: JSON.stringify(scene),
//         contentType: 'application/json; charset=utf-8'
//     });
// }

// Taken from http://stackoverflow.com/questions/1303646/check-whether-variable-is-number-or-string-in-javascript
export function isNumber(obj) { return !isNaN(parseFloat(obj)) }

// http://stackoverflow.com/questions/8834126/how-to-efficiently-check-if-variable-is-array-or-object-in-nodejs-v8
export function isArray(a) {
    return (!!a) && (a.constructor === Array);
};

export function isObject(a) {
    return (!!a) && (a.constructor === Object);
};

export function clamp(num, min, max) {
    return Math.max(min, Math.min(num, max));
};

export function iclamp(num, min, max) {
    return num >= max ? max : num <= min ? min : num;
};
